import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@textadapt/ui';
import { SiteLayout } from './layouts/SiteLayout';
import { Home } from './pages/Home';
import { Features } from './pages/Features';
import { HowItWorks } from './pages/HowItWorks';
import { Pricing } from './pages/Pricing';
import { Security } from './pages/Security';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';

export const App = () => {
  return (
    <ThemeProvider defaultTheme="light">
      <BrowserRouter>
        <SiteLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/security" element={<Security />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </SiteLayout>
      </BrowserRouter>
    </ThemeProvider>
  );
};
